module.exports = __webpack_public_path__ + "static/img/new-img01.2f4ece5d.webp";